import { FC, useState } from 'react';
import toast from 'react-hot-toast';
import { IHookApiResponse } from '../../hooks/IHookApiResponse';
import { useHandleField } from '../../hooks/useHandleField';
import { INewRole } from '../../model/IRole';
import { msg } from '../../msg';
import { IZodErrorsState } from '../../utils/checkFormStateByZod';
import Modal from '../common/Modal';
import RoleItemForm from './RoleItemForm';

const EditRoleForm: FC<{
  isModal: boolean,
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>,
  title: string,
  editRole: (data: INewRole) => IHookApiResponse<INewRole>,
  initNewRoleForm: INewRole,
}> = ({
  isModal,
  setIsModal,
  title,
  editRole,
  initNewRoleForm,
}) => {
    const [isPending, setIsPending] = useState<boolean>(false);
    const [form, setForm] = useState<INewRole>(initNewRoleForm);
    const [errState, setErrState] = useState<Partial<IZodErrorsState<INewRole>>>();

    const handle = useHandleField(setForm);

    const clearState = () => {
      setErrState(() => undefined);
      setForm(initNewRoleForm);
    }

    const handleEditRole = async () => {
      setErrState(() => undefined);
      setIsPending(() => true);
      const response = await editRole(form);
      if (response)
        setErrState(() => response);
      else {
        const id = form.name;
        toast.success(msg('role-edited', { id }));
        setIsModal(() => false);
        clearState();
      }
      setIsPending(() => false);
    };

    return (
      <>
        {!!isModal && (
          <Modal
            title={title}
            style={{ maxWidth: '500px' }}
            onClose={() => {
              setIsModal(() => false);
              clearState();
            }}
            isShown={isModal}
          >
            <RoleItemForm
              mode="edit"
              isPending={isPending}
              form={form}
              handle={handle}
              handleRole={handleEditRole}
              errState={errState}
              btnTitle="Edit Role"
            />
          </Modal>
        )}
      </>
    );
  }

export default EditRoleForm;
